import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Framework } from "@/components/Framework";
import { Process } from "@/components/Process";
import { Founder } from "@/components/Founder";
import { Workshop } from "@/components/Workshop";
import { Recruitment } from "@/components/Recruitment";
import { Results } from "@/components/Results";
import { Audit } from "@/components/Audit";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { DiscoveryModal } from "@/components/DiscoveryModal";
import { Seo } from "@/components/Seo";

export const Home = () => {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // Scroll to a hash target when arriving from another page (e.g. an article).
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: reduce ? "auto" : "smooth" }), 200);
      }
    }

    if (reduce) return;

    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <Seo
        title="XSELL Solutions | GTM Strategy, Revenue Consulting & Recruitment"
        description="XSELL Solutions helps B2B technology and services firms grow — GTM strategy, revenue operations and enterprise sales execution, plus cross-functional recruitment services across engineering, product, operations, leadership and sales."
        path="/"
      />
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Framework />
        <Process />
        <Founder />
        <Workshop />
        <Results />
        <Audit />
        <Recruitment />
        <Contact />
      </main>
      <Footer />
      <DiscoveryModal />
    </div>
  );
};
